module.exports = new __parcel__URL__("TokenFarm_symbol.b82b4f01.png").toString();